var DISMISS_MS = 760;

/**
 * @returns {HTMLElement | null}
 */
export function getGameLoaderElement() {
  if (typeof document === "undefined") return null;
  return document.getElementById("gameLoader");
}

export function markGameLoading() {
  if (typeof document === "undefined") return;
  document.body.classList.add("game-loading");
}

/**
 * Drop the splash below a portal ad without dismissing it.
 * `hidden` is reserved for the real dismiss, which would skip the outro.
 * @param {boolean} behind
 */
export function setGameLoaderBehindAd(behind) {
  var el = getGameLoaderElement();
  if (!el || el.classList.contains("hidden") || el.classList.contains("game-loader--dismiss")) return;
  el.classList.toggle("game-loader--behind-ad", !!behind);
}

/**
 * @returns {Promise<void>}
 */
export function dismissGameLoader() {
  if (typeof document === "undefined") return Promise.resolve();
  var el = getGameLoaderElement();
  if (!el || el.classList.contains("game-loader--dismiss") || el.classList.contains("hidden")) {
    document.body.classList.remove("game-loading");
    return Promise.resolve();
  }

  return new Promise(function (resolve) {
    var done = false;
    var scrim = el.querySelector(".game-loader__scrim");

    var finish = function () {
      if (done) return;
      done = true;
      el.classList.add("hidden");
      el.classList.remove("game-loader--dismiss");
      el.setAttribute("aria-busy", "false");
      el.setAttribute("aria-hidden", "true");
      document.body.classList.remove("game-loading");
      resolve();
    };

    el.classList.add("game-loader--dismiss");
    el.setAttribute("aria-busy", "false");

    if (scrim && typeof scrim.addEventListener === "function") {
      scrim.addEventListener("animationend", function onEnd(e) {
        if (e.target !== scrim) return;
        if (e.animationName !== "game-loader-circle-out") return;
        scrim.removeEventListener("animationend", onEnd);
        finish();
      });
    }

    setTimeout(finish, DISMISS_MS);
  });
}